<template>
  <div>
    <b-card class="bg-white">
      <div class="flex  justify-between  items-center">
        <div>
          <h2 class="text-2xl font-semibold">
            Subscriber Plan
          </h2>

          <small class=" text-muted ">Price</small>
        </div>
      </div>

      <div class="lg:grid md:grid md:grid-cols-2 lg:grid-cols-4  gap-8 mt-12 ">
        <b-card
          v-for="(item, index) in reports"
          :key="'item-' + index"
          :style="{ background: `${item.color}` }"
        >
          <h2 class="font-bold text-lg text-white">{{ item.number }}</h2>
          <p class="font-normal text-white">{{ item.status }}</p>
        </b-card>
      </div>
    </b-card>
  </div>
</template>

<script>
import "../../scss/Index.scss";
export default {
  data() {
    return {
      reports: [
        {
          number: "4000",
          status: "Total SMS",
          color: "#11cdef"
        },
        {
          number: "4000",
          status: "Total E-MAIL",
          color: "#5e72e4"
        },
        {
          number: "",
          status: " ",
          color: "#f5365c"
        },
        {
          number: "",
          status: " ",
          color: "#fb6340"
        }
      ]
    };
  }
};
</script>
